// extracted by mini-css-extract-plugin
module.exports = {"root":"EasyImageCrop_root__Dr3z5","container":"EasyImageCrop_container__JekiL"};